<template>
  <div :class="$style.container">
    <div :class="$style.desktop">
      <a
        :class="[$style.navButtons, { [$style.disableLink]: !hasPageBefore }]"
        :href="pageBefore"
      >
        <ChevronLeftIcon
          height="16px"
          :class="hasPageBefore ? 'icon-gray-1000' : 'icon-gray-400'"
        />
      </a>
      <template v-for="(page, pageIndex) in pagesNumber">
        <span
          v-if="
            pageIndex - 1 === pagesInterval.end && pageIndex !== pagesNumber
          "
          :key="page + 'dots'"
          :class="$style.dots"
        >
          ...
        </span>
        <a
          v-if="
            (pageIndex < pagesInterval.end &&
              pageIndex >= pagesInterval.start) ||
            page === pagesNumber
          "
          :key="page"
          :class="[
            [$style.navButtons],
            { [$style.activePage]: pageIndex + 1 === activePage },
          ]"
          :href="pageLink(pageIndex + 1)"
        >
          {{ page }}
        </a>
      </template>
      <a
        :class="[$style.navButtons, { [$style.disableLink]: !hasPageAfter }]"
        :href="pageAfter"
      >
        <ChevronRightIcon
          height="16px"
          :class="hasPageAfter ? 'icon-gray-1000' : 'icon-gray-400'"
        />
      </a>
    </div>
  </div>
</template>

<script>
import ChevronLeftIcon from 'LkIcons/ChevronLeft.vue'
import ChevronRightIcon from 'LkIcons/ChevronRight.vue'

export default {
  name: 'Paging',

  components: {
    ChevronLeftIcon,
    ChevronRightIcon,
  },

  model: {
    prop: 'activePage',
    event: 'change',
  },

  props: {
    pagesNumber: {
      type: Number,
      required: true,
    },
    activePage: {
      type: Number,
      default: 1,
    },
  },

  computed: {
    hasPageBefore() {
      return this.activePage > 1
    },

    hasPageAfter() {
      return this.activePage < this.pagesNumber
    },

    formatedSelectData() {
      const optionsArray = []
      for (let option = 1; option <= this.pagesNumber; option++) {
        optionsArray.push({
          value: option,
          wording: `Page ${option}`,
        })
      }
      return optionsArray
    },

    pagesInterval() {
      if (this.activePage - 3 < 0) return { start: 0, end: 5 }
      if (this.activePage + 3 > this.pagesNumber)
        return { start: this.pagesNumber - 5, end: this.pagesNumber }
      return { start: this.activePage - 2, end: this.activePage + 3 }
    },

    pageBefore() {
      if (this.hasPageBefore) {
        return this.pageLink(this.activePage - 1)
      }
      return '#'
    },

    pageAfter() {
      if (this.hasPageAfter) {
        return this.pageLink(this.activePage + 1)
      }
      return '#'
    },
  },

  methods: {
    pageLink(pageNumber) {
      if (pageNumber <= 1) {
        return this.$route.path.replace(/\/p\/\d+$/, '')
      }
      return (
        this.$route.path.replace(/\/p\/\d+$/, '').replace(/\/$/, '') +
        `/p/${pageNumber}`
      )
    },
    changePage(pageNumber) {
      window.location.href = this.pageLink(pageNumber)
    },
  },
}
</script>

<style lang="scss" module>
.desktop {
  display: flex;
  gap: 8px;
  justify-content: center;
  margin: 80px auto;
}

.navButtons {
  @include typo-body;

  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 8px;

  text-decoration: none;

  background: none;
  cursor: pointer;

  &:hover {
    background-color: $gray-75;
  }

  &.activePage {
    color: white;

    background-color: $bluko-500;
  }
}

.dots {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
}

.disableLink {
  pointer-events: none;
}
</style>
